module.exports = __webpack_public_path__ + "img/calendar.b3d6e64c.svg";